import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import LeadListUI from '../../../components/superUser/account/LeadListUI'
import LeadUpdateModalSF from '../../../components/superUser/account/LeadUpdateModalSF'
import SendEmailToLeadModalSF from '../../../components/superUser/account/SendEmailToLeadModalSF'
import LeadCreateModalSF from '../../../components/superUser/account/LeadCreateModalSF'
import SendCustomEmailModalSF from '../../../components/superUser/account/SendCustomEmailModalSF'

const LeadListPageUI = ({
  context, errorList, leadList,
  onRefreshClick, onRowClick,
  selectedLead,salesChannelList,ownerUserList,supportOwnerUserList,
  onCopyToClipboard, copyToClipboardText,
  createLeadMode, onCreateLeadClick, onCreateLeadCancel,
  leadUpdateMode, onLeadUpdateClick, onCancelLeadUpdate,
  emailToLeadMode, onSendEmailToLeadClick, onCancelEmailToLead,
  sendCustomEmailMode, onSendCustomEmailClick, onSendCustomEmailCancel
}) => (
  <SuperUserHomePageUI
    context={context} className='pg_su_ld' topnav='accounts'
    centered={!leadList && !errorList} page='leads'
  >
    {
      !leadList && !errorList
      && <SpinnerComponentUI />
    }

    {
      errorList && errorList.length > 0
      && <GenericErrorUI error={errorList[0]} />
    }
    {
      leadList &&
      <LRTableActionsUI
        location='top'
        left={
          <ActionLeftUI context={context} onRefreshClick={onRefreshClick}
            onCreateLeadClick={onCreateLeadClick}
            onSendEmailToLeadClick={onSendEmailToLeadClick}
          />
        }
        right={<span />}
      />
    }

    {
      leadList && leadList.length === 0 &&
      <EmptyListUI createDisabledMessageLabel='No leads added' />
    }

    {
      leadList && leadList.length > 0 &&
      <LeadListUI context={context} leadList={leadList}
        onRowClick={onRowClick}
        onRefreshClick={onRefreshClick}
        onCopyToClipboard={onCopyToClipboard}
        copyToClipboardText={copyToClipboardText}
        onLeadUpdateClick={onLeadUpdateClick}
        onSendCustomEmailClick={onSendCustomEmailClick}
      />
    }

    <LeadCreateModalSF
      context={context} createLeadMode={createLeadMode} onCreateLeadCancel={onCreateLeadCancel}
      onRefreshClick={onRefreshClick} salesChannelList={salesChannelList} ownerUserList={ownerUserList}
      supportOwnerUserList={supportOwnerUserList}
    />

    <LeadUpdateModalSF
      context={context} leadUpdateMode={leadUpdateMode} onCancelLeadUpdate={onCancelLeadUpdate}
      onRefreshClick={onRefreshClick} lead={selectedLead} salesChannelList={salesChannelList}
      ownerUserList={ownerUserList} supportOwnerUserList={supportOwnerUserList}
    />

    <SendCustomEmailModalSF
      context={context} sendCustomEmailMode={sendCustomEmailMode} onSendCustomEmailCancel={onSendCustomEmailCancel}
      lead={selectedLead}
    />

    <SendEmailToLeadModalSF
      context={context} emailToLeadMode={emailToLeadMode} onCancelEmailToLead={onCancelEmailToLead}
    />

  </SuperUserHomePageUI>
)

const ActionLeftUI = ({ context, onRefreshClick, onCreateLeadClick, onSendEmailToLeadClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <IconButtonUI icon='icon-plus' onClick={onCreateLeadClick} />
    {context.permissions.includes('su_superuser_business') &&
      <IconButtonUI icon='icon-envelope-o' onClick={onSendEmailToLeadClick} />
    }
    <span className='g_m_left_100 g_large'><b>Leads</b></span>
  </div>


export default LeadListPageUI